;var Share = (function ($, window) {
    /**
     * Wrapper for AddThis Sharing Endpoints API (which can be replaced easily)
     *
     * Usage: (example) add the following attribute to a share element:
     *
     *      <a ... data-share='{ "type": "facebook", "url": "http://eurocross.nl", "title": "The title" }'></a>
     *
     * For all possible configuration parameters, see subject "Share Forward" on the AddThis website:
     * http://www.addthis.com/academy/addthis-sharing-endpoints
     *
     * Note: Make sure you define a valid `href`, which will be used when social sharing is disabled in the NPO cookies.
     *
     * @param {jQuery}   $target   The target element
     * @param {object=}  config    (optional) Configuration, should at least contain `type` and `url`.
     * @constructor
     */
    var Share = function ($target, config) {
        config = config || {};

        /**
         * Throw an error when the `type` key is not defined in the config
         */
        if (config.type === undefined) {
            throw 'Type not defined in [data-share]. Should be "twitter", "facebook", etc. See https://www.addthis.com/services';
        }

        /**
         * Throw an error when the `url` key is not defined in the config
         */
        if (config.url === undefined) {
            throw 'URL to be shared not defined in [data-share]';
        }

        this._$target = $target;
        this._config = config;

        /**
         * If the attribute `target` is NOT set to '_blank', assume we want a popup instead of a new tab/window
         */
        this._popup = ($target.attr('target') !== '_blank');

        /**
         * Set the URL
         */
        this._setUrl();
    };

    /**
     * The AddThis Sharing Endpoint
     * @type {string}
     */
    Share.prototype.ENDPOINT = 'https://api.addthis.com/oexchange/0.8/forward/{%type%}/offer?';

    /**
     * Build the URL based on the configuration
     *
     * @private
     */
    Share.prototype._setUrl = function () {
        var url = Share.prototype.ENDPOINT,
            params = [];

        /**
         * Set the service_code (eg: twitter, facebook, etc
         * @see https://www.addthis.com/services
         */
        url = url.replace(/{%type%}/, this._config.type);

        /**
         * Map each config key+value to URL parameters.
         * A config of:
         *      data-share='{ "url": "test", "title": "Test" }'
         * Would become:
         *      '?url=test&title=Test'
         */
        Object.keys(this._config).forEach(function (key) {
            if (key === 'type') {
                return false;
            }
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(this._config[key]));
        }.bind(this));

        /**
         * Join the endpoint with the URL parameters and set as endpoint URL
         *
         * @type {string}
         * @private
         */
        this._url = url + params.join('&');
    };

    /**
     * The share event, checks for cookies and proceeds according to cookie settings
     *
     * @param event
     * @returns {boolean}
     */
    Share.prototype.share = function (event) {
        
        event.preventDefault();

        /**
         * Open in a popup or a new tab
         */
        if (this._popup) {
            /**
             * Calculate the max width and height and the centered screen position
             */
            var width = Math.min(screen.width, 500),
                height = Math.min(screen.height, 500),
                left = (screen.width / 2) - (width / 2),
                top = (screen.height / 2) - (height / 2);

            /**
             * Open popup window
             */
            window.open(this._url, 'share', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=' + width + 'px,height=' + height + 'px,top=' + top + 'px,left=' + left + 'px');
        } else {
            /**
             * Open in new tab or window
             */
            window.open(this._url, '_blank');
        }

        return false;
    };

    /**
     * Static builder method to instantiate the Share library for each target
     *
     * @param {object} event
     * @static
     */
    Share.attach = function (event) {
        var $self = $(this),
            config = $self.data('share');

        /**
         * Instantiate a `Share` class for the specific share element/button
         */
        (new Share($self, config)).share(event);
    };

    /**
     * On DOM-ready
     */
    $(function () {
        /**
         * Call a static method with the share elements/buttons
         */
        $('[data-share]').on('click', Share.attach);
    });

    return Share;

})(jQuery, window);
